<template>
  <el-dialog
    v-model="visible"
    :title="
      typeForm === 'createForm'
        ? $t('t_add_socket_group_list')
        : $t('t_update_socket_group_list')
    "
    width="900px"
    align-center
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
      <el-form-item :label="$t('t_socket_group_list_name')" prop="name">
        <el-input
          type="text"
          v-model="form.name"
          clearable
          :placeholder="$t('t_socket_group_list_name_placeholder')"
        ></el-input>
      </el-form-item>

      <div class="">
        <label class="form-label fw-bold">{{ $t("t_search_socket") }}</label>
        <el-form
          :model="searchSocketForm"
          @submit.prevent="fn_searchSocket"
          label-width="auto"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <el-select
                  v-model="searchSocketForm.name"
                  filterable
                  remote
                  allow-create
                  default-first-option
                  clearable
                  :placeholder="$t('t_socket_list_name_placeholder')"
                  :remote-method="(q) => fn_getSuggestions('name', q)"
                  :loading="loadingOptions.name"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-select
                  v-model="searchSocketForm.address"
                  filterable
                  remote
                  allow-create
                  default-first-option
                  clearable
                  :placeholder="$t('t_socket_address_placeholder')"
                  :remote-method="(q) => fn_getSuggestions('address', q)"
                  :loading="loadingOptions.address"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsAddress"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input-number
                  v-model="searchSocketForm.port"
                  :min="1"
                  :max="65535"
                  :placeholder="$t('t_socket_port_placeholder')"
                  controls-position="right"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="fn_searchSocket"
                  :loading="loadingSearch"
                  style="width: 100%"
                >
                  <i class="ri-search-line me-1"></i> {{ $t("t-search") }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="mt-2">
          <el-table
            v-if="listSocketsSearch.length > 0"
            :data="listSocketsSearch"
            size="small"
            border
            stripe
            max-height="200"
          >
            <el-table-column :label="$t('t_socket_list_name')">
              <template #default="scope">
                {{ scope.row.name }} ({{ scope.row.address }}:{{
                  scope.row.port
                }})
              </template>
            </el-table-column>
            <el-table-column width="100" align="center">
              <template #default="scope">
                <el-button
                  :type="
                    form.socket_ids.includes(scope.row.id)
                      ? 'success'
                      : 'primary'
                  "
                  size="small"
                  plain
                  @click="fn_addSocketToGroup(scope.row)"
                  :disabled="form.socket_ids.includes(scope.row.id)"
                >
                  <i
                    :class="
                      form.socket_ids.includes(scope.row.id)
                        ? 'ri-check-line'
                        : 'ri-add-line'
                    "
                  ></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else-if="!loadingSearch" class="text-center text-muted">
            {{ $t("t_no_socket_found") }}
          </div>
        </div>
      </div>

      <hr />

      <div class="mt-3">
        <label class="form-label fw-bold">{{
          $t("t_list_socket_of_group")
        }}</label>
        <el-table
          :data="listSocketsInGroup"
          size="small"
          border
          stripe
          max-height="300"
        >
          <el-table-column :label="$t('t_socket_list_name')">
            <template #default="scope">
              {{ scope.row.name }} ({{ scope.row.address }}:{{
                scope.row.port
              }})
            </template>
          </el-table-column>
          <el-table-column width="100" align="center">
            <template #default="scope">
              <el-button
                type="danger"
                size="small"
                plain
                @click="fn_removeSocketFromGroup(scope.row.id)"
              >
                <i class="ri-close-line"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="text-align: center" class="mt-4">
        <el-button type="primary" :loading="loading" @click="handleFormSubmit">
          {{ typeForm === "createForm" ? $t("t-add") : $t("t-update") }}
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, ref, watch, defineProps, defineEmits } from "vue";
import mushroom from "cem-primary-api";
import MethodService from "../../service/MethodService";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import { Project, Filter } from "mushroomjs";

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  typeForm: {
    type: String,
    default: "createForm",
  },
  idGroup: {
    type: String,
    default: "",
  },
  dataForm: {
    type: Object,
    default: () => ({ name: "", socket_ids: [] }),
  },
});

const emit = defineEmits(["update:modelValue", "success"]);

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const formRef = ref(null);
const loading = ref(false);
const form = reactive({
  name: "",
  socket_ids: [],
});

const rules = {
  name: [
    {
      required: true,
      message: t("valid_required"),
      trigger: "blur",
    },
    {
      min: 1,
      max: 255,
      message: t("valid_max_length") + " 255",
      trigger: "blur",
    },
  ],
};

const searchSocketForm = reactive({
  name: "",
  address: "",
  port: "",
});
const listSocketsSearch = ref([]);
const listSocketsInGroup = ref([]);
const loadingSearch = ref(false);

const optionsName = ref([]);
const optionsAddress = ref([]);
const loadingOptions = reactive({
  name: false,
  address: false,
  port: false,
});

const fn_getSuggestions = async (field, query) => {
  if (!query) {
    if (field === "name") optionsName.value = [];
    if (field === "address") optionsAddress.value = [];
    return;
  }

  loadingOptions[field] = true;
  try {
    let filter = Filter;
    if (field === "port") {
      filter = filter.eq("port", query);
    } else {
      filter = filter.regex(field, query.trim(), "i");
    }

    const { result } = await mushroom.api_socket.getAllAsync({
      filters: filter.build(),
      fields: Project.include(field).build(),
    });

    const uniqueValues = [...new Set((result || []).map((i) => i[field]))]
      .filter((val) => val !== undefined && val !== null)
      .map((val) => ({ value: val.toString(), label: val.toString() }));

    if (field === "name") optionsName.value = uniqueValues;
    if (field === "address") optionsAddress.value = uniqueValues;
  } catch (e) {
    console.error(`Error fetching ${field} suggestions:`, e);
  } finally {
    loadingOptions[field] = false;
  }
};

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      form.name = props.dataForm.name || "";
      form.socket_ids = props.dataForm.socket_ids || [];
      searchSocketForm.name = "";
      searchSocketForm.address = "";
      searchSocketForm.port = undefined;
      listSocketsSearch.value = [];
      fn_fetchSocketsInGroup();
      fn_searchSocket();
      formRef.value?.clearValidate();
    }
  }
);

const closeDialog = (done) => {
  formRef.value?.clearValidate();
  if (typeof done === "function") done();
  else visible.value = false;
};

const fn_fetchSocketsInGroup = async () => {
  if (!form.socket_ids || form.socket_ids.length === 0) {
    listSocketsInGroup.value = [];
    return;
  }
  try {
    const { result } = await mushroom.api_socket.listAsync({
      filters: Filter.in("id", form.socket_ids).build(),
      fields: Project.include("id", "name", "address", "port").build(),
    });
    if (result) {
      listSocketsInGroup.value = result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
};

const fn_searchSocket = async () => {
  loadingSearch.value = true;
  try {
    let filter = Filter;
    if (form.socket_ids && form.socket_ids.length > 0) {
      filter = filter.nin("id", form.socket_ids);
    }
    if (searchSocketForm.name)
      filter = filter.regex("name", searchSocketForm.name.trim(), "i");
    if (searchSocketForm.address)
      filter = filter.regex("address", searchSocketForm.address.trim(), "i");
    if (searchSocketForm.port)
      filter = filter.eq("port", parseInt(searchSocketForm.port));

    const { result } = await mushroom.api_socket.getAllAsync({
      filters: filter === Filter ? "" : filter.build(),
      fields: Project.include("id", "name", "address", "port").build(),
    });
    if (result) {
      listSocketsSearch.value = result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  } finally {
    loadingSearch.value = false;
  }
};

const fn_addSocketToGroup = (socket) => {
  if (form.socket_ids.includes(socket.id)) {
    toastr.warning(t("t_socket_ip_port_duplicate"));
    return;
  }
  form.socket_ids.push(socket.id);
  // Add to local list for immediate display
  if (!listSocketsInGroup.value.find((s) => s.id === socket.id)) {
    listSocketsInGroup.value.push(socket);
  }
};

const fn_removeSocketFromGroup = (socketId) => {
  form.socket_ids = form.socket_ids.filter((id) => id !== socketId);
  listSocketsInGroup.value = listSocketsInGroup.value.filter(
    (s) => s.id !== socketId
  );
};

const handleFormSubmit = async () => {
  if (!formRef.value) return;

  await formRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      try {
        if (props.typeForm === "createForm") {
          const response = await mushroom.api_socket_group.createAsync({
            name: form.name.trim(),
            socket_ids: form.socket_ids,
          });
          if (response.result) {
            toastr.success(t("toastr_add_success"));
            emit("success");
            visible.value = false;
          }
        } else {
          const response = await mushroom.api_socket_group.partialUpdateAsync({
            id: props.idGroup,
            name: form.name.trim(),
            socket_ids: form.socket_ids,
          });
          if (response.result) {
            toastr.success(t("toastr_update_success"));
            emit("success");
            visible.value = false;
          }
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
        MethodService.showError(e.code);
      } finally {
        loading.value = false;
      }
    }
  });
};
</script>
